import * as React from "react";

const SendIcon = (props) => (
	<svg
		width={19}
		height={19}
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m8.308 10.692 4.846-4.846M18.11 2.89l-4.09 13.294c-.367 1.192-.55 1.788-.867 1.985a1 1 0 0 1-.912.076c-.344-.143-.624-.7-1.182-1.816l-2.59-5.182a2 2 0 0 0-.193-.342 1 1 0 0 0-.18-.181 2 2 0 0 0-.331-.186L2.572 7.94C1.457 7.382.899 7.103.756 6.759a1 1 0 0 1 .076-.913c.197-.316.793-.5 1.985-.867L16.112.89c.937-.29 1.405-.434 1.722-.317a1 1 0 0 1 .594.594c.116.316-.028.784-.316 1.72z"
			stroke={props ? props.stroke : "#fff"}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default SendIcon;
